import { ApplicationTargetEnum } from '../types/app-selection';

const APP_TARGET_LABELS = new Map<string, string>([
    [ApplicationTargetEnum.QC, 'CT'],
    [ApplicationTargetEnum.CA, 'Circle K'],
]);

export const formatAppTargets = (
    appTargets: string[] | null | undefined
): string =>
    (appTargets ?? [])
        .map((target) => APP_TARGET_LABELS.get(target) ?? target)
        .join(', ');
